import formService from '../service/formService';
export  const  gridScript = {
    data(){
        return{
            descriptions: []
        }
    },
    methods:{
        asyncRequest(url, type, param, callback) {
            return formService.request(url, type, param, callback);
        },
		setReadonly(props, trueOrFalse) {
		    this.descriptions.forEach(item => {
		        if (props.some(prop => prop === item.fieldName)) {
		            item.readOnly = trueOrFalse;
		        }
		    })
		},
		hide(props) {
			debugger
		    let index = null;
		    let temp = null;
		    this.descriptions.forEach((item,i) => {
		        if (props.some(prop => prop === item.fieldName)) {
		            index = i;
		            item.hidden = true;
		            temp = item;
		        }
		    });
		    Vue.set(this.descriptions, index, temp);
		},
    }
};
export default gridScript
